export const terms = `
<div class="WordSection1">

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><b><span lang="EN-MY">TERMS
&amp; CONDITIONS OF SHENMA CUSTOMER PORTAL ACCESS</span></b></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">PLEASE
READ &amp; UNDERSTAND THE FOLLOWING TERMS AND CONDITIONS WHICH GOVERN YOUR
ACCESS TO THE SHENMA CUSTOMER PORTAL WEBSITE (THIS "WEBSITE") AND USE
OF THE SERVICES PROVIDED THROUGH THIS WEBSITE. BY ACCESSING THIS WEBSITE AND/OR
USING THE SERVICES, YOU AGREE TO BE BOUND BY THESE TERMS OF ACCESS AND THE SHENMA
CUSTOMER PORTAL AGREEMENT BELOW (THE "SHENMA CUSTOMER PORTAL
AGREEMENT"). </span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">FROM
TIME TO TIME, WE MAY NEED TO REVISE THESE TERMS AND CONDITIONS, IN WHICH CASE
WE WILL POST THE REVISED TERMS AND CONDITIONS ON THIS WEBSITE. IF YOU CHOOSE TO
CONTINUE USING THIS WEBSITE AFTER ANY REVISION TO THESE TERMS AND CONDITIONS,
YOU SHALL BE DEEMED TO HAVE ACCEPTED THE REVISED TERMS AND CONDITIONS
ACCORDINGLY</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">IF AT
ANY TIME YOU DO NOT ACCEPT ANY OF THE TERMS AND CONDITIONS, YOU MUST
IMMEDIATELY DISCONTINUE ALL ACCESS TO THIS WEBSITE AND USE OF THE SERVICES.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">PLEASE
FIND THE BELOW TERMS AND CONDITIONS;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">These
Terms and Conditions explain your responsibilities and obligations relating to
your use of the "SHENMA Customer Portal" (as defined below).</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Definitions</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">The
following words and expressions carry the following meaning:</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Loan
Account”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
your loan with SHENMA Credit.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Loan
Account Number”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
a unique twelve (12) digit number assigned to your Loan Account.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Loan
Application Status”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
your new loan application to SHENMA Credit, which the status is shown in SHENMA
Customer Portal.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Loan
Payment Service”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
you can make repayment to your Loan Account using SHENMA Customer Portal.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“One
Time Password (OTP)”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY" style="color:#202124;">Means a six (6) digit password generated
and sent to your registered mobile number for validation of your
transaction.&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Password”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
a unique string of characters chosen by you and known only to you, which must
be keyed in by you for authentication of your User Name and grant of access to
the SHEMA Customer Portal.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Personal
Image”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
a selection of image made by you in registration of SHENMA Customer Portal. </span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Security
Phrases”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
a word(s) enter by you in registration of SHENMA Customer Portal.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“SHENMA
Customer Portal”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
a portal for SHENMA Credit customer to access to Loan Account, Application
Status checking and monthly instalment repayment. You may access through the
internet, upon the correct input of your User Name and Password.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“Transaction
History”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
the payment records made by you to your Loan Account(s).</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">“User
Name”</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Means
a unique name made up of a string of characters chosen by you which must be
keyed in by you in order for the SHENMA Customer Portal system to associate the
User Name with your user profile and Loan Account(s).</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Application to subscribe to the SHENMA Customer
Portal</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>1.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You may apply to use the SHENMA Customer Portal subject at all times
to the SHENMA Credit's sole and absolute discretion whether to reject or accept
your application.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>1.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Where SHENMA Credit has rejected your application, SHENMA Credit is
not obliged to provide any reason for such rejection or to respond to any
request for information.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Acceptance of Terms and Conditions</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>2.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that the use of the SHENMA Customer Portal by you, will
constitute your acceptance of these Terms and Conditions as well as to the
inherent risks in conducting any transaction over the internet.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Equipment, Software and Network Access</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>3.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that it is your obligation to maintain the device or terminal
used in accessing the SHENMA Customer Portal.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:39.6pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Gaining Access to the SHENMA Customer Portal</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>4.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">If you have a Loan Account with the SHENMA Credit which you wish to
access via the SHENMA Customer Portal, you may subscribe to the same with the following
procedure:</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>4.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">For your first time logon, you would be required to key in your Loan
Account Number on the relevant customer portal registration page on the www.shenmacredit.com.my
website.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>4.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Upon the successful registration and verification of your loan account
number well as your acceptance of these Terms and Conditions, One Time Password
(OTP) will send to your mobile phone number that registered with SHENMA Credit,
key in the six (6) digit OTP to the portal. You would be required to create a
User Name, Password, Security Phrases and select the Personal Image.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>4.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Upon completion and acceptance of your registration, your access to
the SHENMA Customer Portal is activated.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:39.6pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">To access the SHENMA Customer Portal, each time
you log on you will need to key in:</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Your User Name; </span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Your Password, and</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Choose your Personal Image and enter your Security Phrase.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that SHENMA Credit has the right to invalidate your User Name
and Password without being obliged to offer you any explanation or prior notice
and that you will not hold SHENMA Credit liable for any loss or damage which
you may suffer as a result of such invalidation of your User Name and Password.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You may change your User Name &amp; Password at anytime but any
changes will be effective if accepted by SHENMA Credit. You agree that SHENMA
Credit uses your User Name &amp; Password to identify you and acknowledge that
you must keep both your User Name &amp; Password secret and secure and exercise
reasonable care to prevent unauthorized access and/or use.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Once you have logged on to the SHENMA Customer Portal, you must not
leave the terminal or other devices from which you have accessed the SHENMA Customer
Portal at anytime or let anyone else use it until you have logged off. You are
responsible for ensuring that you have logged off the service at the end of
each session.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>5.7.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">We may have to request from you your User Name, (but not your
Password) in order to provide maintenance services to you. If you supply us
with your User Name we will keep it secret. NEVER SUPPLY YOUR PASSWORD TO
ANYONE.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:39.6pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:39.6pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">SHENMA Customer Portal</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>6.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Upon the activation of the SHENMA Customer Portal, you will be able
to access the Loan Account details, Loan Application Status, Loan Payment Service
and/or any other service by 3rd Party may from time to time make available to
you on the website.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>6.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree and accept that any instructions which you may issue shall
at all times be subject to such limits and conditions as may be fixed or
specified by SHENMA Credit from time to time at its absolute discretion.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>6.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">In cases which involve or require the consent or approval of third
parties, SHENMA Credit's obligations to perform any instructions would be
subject to such consent and approval being obtained by you.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>6.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You shall ensure that there are sufficient funds or credit limit at
all times available in your bank account(s), credit card(s) or e wallet(s) to
perform any of your payment.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>6.5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that SHENMA Credit has the absolute right to add, suspend,
limit, withdraw, cancel or vary any transactions, facilities, services and
products that can be accessed by you through the SHENMA Customer Portal and the
scope and/or extent of such transactions, facilities, services and products.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:39.6pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:39.6pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">7.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Authorization</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>7.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You hereby authorise SHENMA Credit to comply with all instruction(s)
given in respect of the SHENMA Customer Portal accessed using your User Name
and Password as instruction(s) properly authorized by you even if they may
conflict with any other mandate given at any time concerning your loan accounts
or affairs.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>7.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that such instruction(s) shall be binding on yourself upon
its transmission to SHENMA Credit and the instructions cannot be changed or
withdrawn without the SHENMA Credit’s consent and that SHENMA Credit is not
further obliged to check the authenticity of such Instruction(s).</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><s><span lang="EN-MY"><span style="text-decoration:none">&nbsp;</span></span></s></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">8.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Instructions</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>8.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You hereby agree that it is your responsibility to review the Transaction
History pertaining to payment made through SHENMA Customer Portal initiated on
your instruction.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>8.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Should you have any reason to believe that an instruction has not
been accurately or completely received by SHENMA Credit, you shall inform SHENMA
Credit by telephone no later than twenty four (24) hours after transmission of
the relevant instruction(s).</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>8.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Any instructions to SHENMA Credit for cancellation, revocation,
reversal or amendment or clarification of your earlier instructions, can only
be effected, if your request is received and effected before the earlier instruction
is executed.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>8.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Credit reserves the right at its sole discretion, to decline
to carry out any of your instructions where your instructions are inconsistent
with the SHENMA Credit's policy or laws or for any other reasons whatsoever.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>8.5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Where you give instructions to SHENMA Credit to effect transactions
in relation to the SHENMA Customer Portal, you shall provide accurate and
complete details as required by SHENMA Credit.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>8.6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Credit shall not be liable for any failure, delay or
shortcoming by any third party when they are executing the instructions.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><s><span lang="EN-MY"><span style="text-decoration:none">&nbsp;</span></span></s></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><s><span lang="EN-MY"><span style="text-decoration:none">&nbsp;</span></span></s></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">9.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">Service Availability</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>9.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Customer Portal are intended to be available 7 days a week,
24 hours a day but there is no warranty that the same will be available at all
times. SHENMA Credit will use reasonable efforts to inform you of any or all
services under the SHENMA Customer Portal which are not available from time to
time.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">10.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Loan Account Information</span></p>

<p class="MsoNoSpacing" style="margin-left:43.2pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-43.2pt"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>10.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Credit does not warrant the accuracy of any information
pertaining to your Loan Account(s) or transactions as reported through the
SHENMA Customer Portal. You must ensure that the information you provide to us
in relation to the SHENMA Customer Portal is true, complete and updated.</span></p>

<p class="MsoListParagraph" style="margin-left:43.2pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>10.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that the information pertaining to your Loan Account(s) or
transactions as reported through the SHENMA Customer Portal shall not for any
purpose whatsoever be taken as conclusive of the status of your Loan Account(s)
or transaction.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">11.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Confidentiality</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>11.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You accept that you will be responsible for the confidentiality and
use of your User Name and Password and that you shall at no time and under no
circumstances reveal your User Name and Password to anyone including the staff
of SHENMA Credit.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>11.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You undertake to observe all security measures concerning your user Name
and Password or generally in respect of the use of the SHENMA Customer Portal.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>11.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Should you have any reason to believe that any of your User Name and
Password have been misused and/or compromised by disclosure, discovery or you
must inform SHENMA Credit immediately.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>11.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Should you receive any data and information through the SHENMA
Customer Portal which is not intended for you, you agree that all such data or
information shall be deleted from your computer system immediately and that you
will notify SHENMA Credit by telephone immediately and in any case no later
than twenty four (24) hours.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">12.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Disclosure of Customer's Information</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>12.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Credit agrees not to disclose to third parties any financial
information you have provided or that SHENMA Credit has obtained about Loan Account(s)
and the transactions thereunder unless it is:</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:108.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-39.6pt;line-height:normal"><span lang="EN-MY">12.1.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">to comply with laws and regulations or
appropriate government agency or court orders or requests,</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:108.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-39.6pt;line-height:normal"><span lang="EN-MY">12.1.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">to verify the existence and condition of your loan
account for a third party, such as a credit bureau agency, debts management
agency,</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:108.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-39.6pt;line-height:normal"><span lang="EN-MY">12.1.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">when it is necessary to complete a transaction,</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:108.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-39.6pt;line-height:normal"><span lang="EN-MY">12.1.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">to provide services relating to your loan account
or to offer other products and services and to such service providers relating
thereto (if any),</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:108.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-39.6pt;line-height:normal"><span lang="EN-MY">12.1.5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">in connection with examination by authorities,</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:108.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-39.6pt;line-height:normal"><span lang="EN-MY">12.1.6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-MY">with your written permission,</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>12.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You understand that while SHENMA Credit will use its best endeavours
to ensure that all information transmitted or received using the SHENMA
Customer Portal is secure and cannot be accessed by unauthorised third parties,
SHENMA Credit does not warrant the security of any information transmitted by
you using the SHENMA Customer Portal. Accordingly, you agree to accept the risk
that any information transmitted or received using the SHENMA Customer Portal may
be accessed by unauthorised third parties and you agree not to hold SHENMA
Credit liable for any such unauthorised access or any loss or damage suffered
as a result.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">13.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Liabilities</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>13.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You acknowledge that SHENMA Credit makes no warranties or
representations of any kind with respect to the SHENMA Customer Portal, whether
express or implied. Neither SHENMA Credit or any other parties involved in the
creation, production or delivery of the SHENMA Customer Portal assume any
responsibilities with respect to your use thereof. No oral or written information
or advice given by SHENMA Credit or SHENMA Credit's employees shall create a
warranty or in any way increase the scope of this warranty, and you may not
rely on any such information or advice. </span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>13.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">TO THE EXTENT PERMITTED BY APPLICABLE LAWS, SHENMA Credit SHALL NOT
BE RESPONSIBLE OR LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT
DAMAGES (INCLUDING LOSS OF INCOME / PROFITS, LOSS OF OPPORTUNITY, LOSS OF
SAVINGSS AND BUSINESS INTERRUPTION) OR SPECIAL OR EXEMPLARY DAMAGES (INCURRED
OR SUFFERED BY YOU OR ANY OTHER PERSON AS A CONSEQUENCE OF USING THE SHENMA
CUSTOMER PORTAL).</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>13.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Due to the nature of the SHENMA Customer Portal, SHENMA Credit will
not be responsible for any loss of or damage to your data, software, equipment,
network access or other equipment used to access the SHENMA Customer Portal.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">14.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Proprietary Rights</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>14.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You acknowledge that all proprietary rights and intellectual
property rights in the SHENMA Customer Portal (including without limitation,
the shenmacredit.com.my website) belongs to SHENMA Credit.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">15.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Fees and Charges</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>15.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You acknowledge that SHENMA Credit shall be entitled to levy or
impose service charges or transaction fees from time to time in respect of your
use of or access to the SHENMA Customer Portal.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>15.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You acknowledge that you are responsible for all charges imposed by
service providers in enabling you to access and/or connect to the SHENMA
Customer Portal. You are also responsible for any fees and charges imposed by
any network service provider.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">16.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Suspension or Termination of Services</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>16.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Notwithstanding anything herein to the contrary, SHENMA Credit may
at any time, in its absolute discretion suspend or terminate your right of
access to any of the SHENMA Customer Portal without notice for any reason
whatsoever and without any obligation to give any reasons.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>16.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Credit has the right to terminate your right of access to the
SHENMA Customer Portal should you cease to have any active Loan Account(s) with
SHENMA Credit.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>16.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You may terminate the SHENMA Customer Portal by giving prior written
notice to SHENMA Credit. The SHENMA Customer Portal will be cancelled within
seven (7) days from the date of the receipt of the notice of termination and
you agree that SHENMA Credit shall not be obliged to effect any of your instructions
received on any day falling after the receipt of your notice of termination. </span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>16.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You acknowledge that termination will not affect your liability or
obligations in respect of instructions processed by SHENMA Credit on your
behalf.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">17.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Indemnity</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>17.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You hereby agree to indemnify and keep SHENMA Credit indemnified
from and against any and all claims, losses, liabilities, cost and expenses
(including but not limited to any legal fees) arising directly or indirectly or
which may arise out of your breach or violation of these Terms and Conditions
or any third party rights or your use or purported use of the SHENMA Customer
Portal or due to the delay and/or failure of such services.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">18.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Notices</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You hereby consent to all notices and other communications which
concern the SHENMA Customer Portal or are required under these Terms and
Conditions or may be given by SHENMA Credit in any one of the following
manners:</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">By broadcasting a notification message on SHENMA Customer Portal.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">By ordinary post to your last address in SHENMA Credit's records and
such notification shall be deemed received two (2) days after posting.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">By electronic mail to your last known e-mail address in SHENMA
Credit's records and such notification shall be deemed received twenty four
(24) hours after sending.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">By way of advertisement made once in any national newspaper and such
notification shall be deemed effective on the date of publication of the
advertisement in any such newspaper.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">Broadcasting a message on the shenmacredit.com.my website.</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>18.7.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">If notified to you in any other manner as SHENMA Credit deems fit.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">19.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Waiver</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>19.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that the failure of SHENMA Credit, whether continuous or
otherwise, to exercise any rights, power, privileges, remedies or provisions of
these Terms and Conditions or SHENMA Credit's failure or delay to insist on
compliance with any of these clauses shall not constitute a waiver by SHENMA
Credit of any such rights, power, privileges, remedies or provisions of these
Terms and Conditions.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">20.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Severability</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>20.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree that if any undertakings and/or part of these Terms and
Conditions are held to be invalid or unenforceable pursuant to applicable law,
then the invalid and unenforceable provision will be deemed superseded by a
valid, enforceable provision that most closely matches the intent of the
original provision and that all other provisions of the Terms and Conditions
shall continue in full force and effect.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">21.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Variations of Terms and Conditions</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>21.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">SHENMA Credit reserves the right to add, modify, delete or vary any
of these terms and conditions by way of notice as deemed suitable by SHENMA
Credit.</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>21.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">You agree to view these Terms and Conditions regularly and your
continued access or use of the shemacredit.com.my website and/or SHENMA
Customer Portal after any such additions, modifications, deletions or
variations become effective will constitute your acceptance to the variation of
these Terms and Conditions.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">22.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Dispute and Enquiries</span></p>

<p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>22.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">If you have any enquiries or require any assistance, please refer to
our customer care at 03-92123838 or email to </span><span lang="EN-MY"><a href="mailto:wecare@shenmacredit.com.my">wecare@shenmacredit.com.my</a></span><span lang="EN-MY">. </span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>22.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">In the event that you have any complaints and/or disputes arising
from the SHENMA Customer Portal and these Terms and Conditions, please refer
the matter to SHENMA Credit at the contact stated in clause 22.1 specifying the
nature of your complaint and/or dispute. You hereby agree to try to settle the
matter amicably.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-18.0pt;line-height:normal"><span lang="EN-MY">23.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span lang="EN-MY">Law and Jurisdiction</span></p>

<p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:43.2pt;margin-bottom:.0001pt;text-align:justify;
text-justify:inter-ideograph;text-indent:-43.2pt;line-height:normal"><span lang="EN-MY"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>23.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; </span></span><span lang="EN-MY">The terms and Conditions will be governed by the Laws of Malaysia
and all disputes shall be resolved by the Courts of Malaysia.</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">--------------------------------------------------------------------------------------------------------------------------------------</span></p>

<p class="MsoListParagraph" style="margin-top:0cm;margin-right:0cm;margin-bottom:
0cm;margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">&nbsp;</span></p>

<p class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
justify;text-justify:inter-ideograph;line-height:normal"><span lang="EN-MY">Online
Payment Processing Service </span></p>

<p class="MsoNormal" style="margin-top:15.0pt;margin-right:0cm;margin-bottom:
7.5pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Terms of Use</span></b></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><span lang="EN-MY" style="color:#333333">PLEASE READ THESE
TERMS CAREFULLY. BY USING FPX YOU AGREE TO BE BOUND BY THESE TERMS.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">These
terms apply to your access to, and use of all or part of this page including
any website owned by PayNet where these terms are posted (“the Sites”). If you
are using this page on behalf of any entity, you represent and warrant that you
are authorised to accept these terms on such entity’s behalf and that such
entity agrees to indemnify you and PayNet for violations of these terms. This
agreement contains disclaimers and other provisions that limit our liability to
you.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">In the
event there is any conflict or inconsistency between these terms and any other
terms of use that appear on the Sites, these terms will govern. However, if you
navigate away from the Sites to a third party site, you may be subject to
alternative terms and conditions of use, as may be specified on such site. In
such event, the terms and conditions of use applicable to that site will govern
your use of that site.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Definitions</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">In
this terms and conditions, "You", "Yours" means any person
or entity using FPX (“Service”), unless otherwise stated. “PayNet”,
"We", “Us” or "Our" will refer collectively to Payments
Network Malaysia Sdn Bhd Sdn Bhd (836743-D) as the owner and operator of FPX
unless otherwise stated. All references to a “Financial Institution” refer to
the FPX participating bank(s) that offers the Internet Banking facilities that
you are dealing with. All references to a “Merchant” refer to the FPX
participating merchant(s) or seller(s) that subscribe to FPX as one of the
payment options. All references to an “Acquirer” refer to the participating
“Financial Institution” and/or “non-Financial Institution” who acquires
Merchants to subscribe to FPX.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">The Service</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">By
accessing and using this page you hereby agree and accept the terms and
conditions for FPX as contained herein. If you do not accept these terms,
please immediately discontinue your access to this page. We may change the
terms periodically without prior notice, so please check them from time to time
as your continued use of this page signifies your acceptance of any changed
term.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Disclaimer</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We are
not responsible for interruptions or limitations to the Service which are
caused or arise from the Merchant’s and/or the Financial Institution’s, as the
case maybe, system capacity limitations, system repairs or modifications, or in
response to suspected fraud, abuse, hacking or malicious viruses, or misuse of
the internet network. You agree that the Service may be interrupted due to
maintenance, updates or system or network failures and we disclaims all
liability for damages caused by any such interruption or errors in functioning.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We are
not responsible for any service outages, loss of data, inability to retrieve
data, or service limitations or interruptions which are caused or arise from
act or omission of the Merchant(s) and/or the Financial Institution(s). We are
not liable for any incidental, punitive or consequential damages caused or
arise out of such events.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">While
every care will be taken by us to provide the Service and ensure a high level
of security, we disclaims all liability whatsoever for any loss, alteration,
destruction or disclosure to any third party whomsoever, of any of your data or
other data howsoever caused or arising including without limitation, delays,
interceptions, non-deliveries or misuse as a result of any interruption,
suspension or termination of our Service(s). Further, we cannot guarantee and
does not warrant the accuracy of any data delivered to us by the Merchants who
sells their products to you. By accessing and using this Page, you expressly
understand and agree that we disclaim any and all responsibility or liability
for the accuracy, content, completeness, legality, reliability, or operability
or availability of information or material that we receive from the Sites,
Merchant(s) and Financial Institution(s).We disclaim any responsibility for the
deletion, failure to store, misdelivery, or untimely delivery of any
information or document derived from the system and Sites.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We
make no warranty that :</span></p>

<ul type="disc">
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">the Service and the
     Sites will meet your requirements;</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">the Service will be
     uninterrupted, timely, secure or error-free; and</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">the results that may
     be obtained from the Service will be accurate or reliable.</span></li>
</ul>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We
disclaim all liability for impossibility of access, poor use conditions caused
by inappropriate equipment, disturbances attributable to internet service
providers, saturation of the internet network or due to any other reason. We
make no warranties or representations for the delivery of messages sent through
our system to anyone.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Personal Data</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We may
collect your personal information such as email address for the purpose of
sending you a written confirmation status of your payment instruction via FPX.
This personal information is optional and will only be collected when you
provide the details when completing the form in this page.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">For
explanation of PayNet’s policy related to collection, use, and process of your
personal data, please read the Privacy Policy. By accessing and using this
page, you hereby consent and agree to the terms specified in the Privacy Policy
with respect to our processing of your personal data. If you do not consent to
the said terms, kindly contact us at the contact details provided in the
Privacy Policy.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Online payment
processing service</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">FPX
facilitates a purchase made by you from a Merchant that is acquired by the
Acquirer for FPX. This page stores information from you, such as payment
instructions and personal information. We process payment transactions through
FPX network or through a participating Acquirer, as applicable. When you
chooses to pay for purchases made with FPX, you authorise us to submit charges
(and, in the case of refunds, credits) to your Financial Institution. We will
assist in accessing and processing the payment request via FPX. Purchases made
through FPX are also subject to the terms governing you and your Financial
Institution.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">You
may not use FPX to process payment transaction or transfer money between you
and the Merchant that is unrelated to a purchase of a product/service. FPX may
not be used to facilitate the purchase of cash equivalents or any illegal goods
or services or for any other underlying illegal transaction.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">You
acknowledge and agree that your purchases through FPX are transactions between
you and the Merchant and not with us.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">By
using FPX, you authorise the use of FPX to complete a payment request to the
Merchant, and you authorise us to process the payment transaction with the
Financial Institution that you have chosen.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">You
are responsible to obtain a transaction receipt from the Merchant when you use
FPX to make a payment for the purchase. We are under no obligation to provide
you with a receipt or other written confirmation in connection with the payment
transaction made with an online Merchant.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">If you
have an enquiry regarding a payment made with FPX, or you believe there has
been an error or unauthorised transaction regarding a payment transaction using
FPX, please contact us at </span><span lang="EN-MY" style="color:black"><a href="mailto:customersupport@paynet.my">customersupport@paynet.my</a></span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Release</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">You
hereby agree to release PayNet (and our officers, directors, agents,
subsidiaries, joint ventures and employees) from any and against all claims,
actions, losses, demands, costs, expenses and damages (actual and
consequential) including legal costs on full indemnity basis of every kind and
nature that you may incur or suffer arising out of or in any way connected with
dispute between you and the Merchant(s) or between you and the Financial
Institution(s).</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Links</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">Links
from or to websites outside of this page are meant for connecting to the
Financial Institution’s Internet Banking log-in pages to initiate payment via
FPX. Such linked log-in pages are owned and operated by third parties and as
such are not under the control of PayNet. Therefore PayNet is not responsible
and makes no warranties in respect of the contents of those websites or pages,
the third parties named therein or their products and services. Furthermore,
the links provided in this page shall not be considered an endorsement or
verification or approval of such linked websites or the contents therein.
Linking to any other site is at your sole risk and PayNet will not be
responsible or liable for any damages losses and actions which may arise out of
or in connection with the linking of the website. It is advisable for you to
read the privacy policy statements (if any) of any websites which are linked to
this page.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Copyright</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">Unless
otherwise indicated, the copyright in this page and its contents, including but
not limited to the text, images, graphics, sound files, animation files, video
files, and their arrangement, PayNet and FPX logo, name, brand, images are the
property of PayNet, and are protected by applicable Malaysian and international
copyright laws. No part or parts of this page may be modified, copied,
distributed, retransmitted, broadcast, displayed, performed, reproduced,
published, licensed, transferred, sold or commercially dealt with in any manner
without the expressed prior written consent of PayNet.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">You
also may not, without PayNet’s expressed prior written consent, insert a link
to this page on any other website, frame or "mirror" any material
contained on this page or on any other server. Any such unauthorised
reproduction, retransmission or copying or modification of any of the contents
of this page may be in breach of statutory or common law rights which could be
the subject of legal action. If such event occurs, PayNet disclaims all
liability which may arise from any such unauthorised acts.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Exclusion of
liability</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">PayNet
shall in no event be liable for any loss or damages howsoever arising whether
in contract, tort, negligence, strict liability or any other basis, including
without limitation, direct or indirect, special, incidental, consequential or
punitive damages, or loss profits or savings arising in connection with your
access or use or the inability to access or use this page (or any third party
link to or from this page), reliance on the information contained in the page,
any technical, hardware or software failure of any kind, the interruption,
error, omission, delay in operation, computer viruses, or otherwise.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">This
exclusion clause shall take effect to the fullest extent permitted by law.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Indemnity</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">You
hereby irrevocably and unconditionally agree to indemnify and keep indemnified
PayNet from all actions, liabilities, claims, losses, expenses and damages, including
any legal fees that may be incurred by PayNet in connection with or arising
from :</span></p>

<ol start="1" type="1">
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">your use or misuse
     of this page and the service(s) provided herein, or</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">your breach of these
     terms howsoever occasioned, or</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">any intellectual
     property right or proprietary right infringement claim made by a third
     party against PayNet in connection with your unauthorised use of such
     intellectual property rights on this page.</span></li>
</ol>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Access Termination</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">PayNet
reserves the right to suspend your access and/or your use of this page at any
time should you violate any of these terms and conditions, and/or the privacy
policy.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Taxes</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">It is
your responsibility to determine, if any, taxes apply to the payments you make
or receive, and it is your responsibility to collect or remit the correct tax
to the appropriate tax authority. We are not responsible to determine, collect
or remit the applicable taxes from any transaction unless stated otherwise. All
fees related to our services are excluding any taxes or other deductions,
unless stated otherwise. Any deduction or payment for any taxes is your sole
responsibility.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">General</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">These
terms and conditions are governed by and are to be construed in accordance with
the laws of Malaysia. By accessing this page and using FPX, you hereby consent
to the exclusive jurisdiction of the Malaysian courts in Kuala Lumpur, Malaysia
in all disputes arising out of or relating to the use of this page.</span></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">PayNet
makes no representation that the materials, information, functions and/or
services provided on this page are appropriate or available for use in
jurisdictions other than Malaysia.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN-MY">

<hr size="0" width="100%" noshade="" style="color:#333333" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:15.0pt;margin-right:0cm;margin-bottom:
7.5pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><span lang="EN-MY" style="color:#333333">Privacy Policy</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Privacy Policy</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">This
policy describes the way we collect, store, use and protects your personal
information. You accepted this policy when you signed up for our service(s). We
may change the terms of this policy at any time, so please check them on this
page, from time to time, as your continued use of this page signifies your
acceptance of any changed term.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Information we collect</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We
collect certain personal information about you from the information you submit
on this page; the information we collect from the Financial Institution and
non-Financial Institution; and the information we collect from other
sources.The information you give to the Financial Institution that we may
collected may include your name, email address, national registered
identification number, phone number, financial account information such as bank
account number and any other information that is required to assist and
complete the transaction made using FPX.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Use of Information
we collect</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">This
notice relates specifically to submission of your personal information on this
page to PayNet. We use your personal information for a number of reasons,
including:</span></p>

<ul type="disc">
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">to process your
     payment for purchases of products and services via FPX;</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">to inform you about
     our products, events or promotional purposes;</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">to respond to your
     enquiry and requests for information;</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">to maintain
     appropriate records for internal administrative purposes;</span></li>
 <li class="MsoNormal" style="color:#333333;text-align:justify;text-justify:inter-ideograph;
     line-height:normal;"><span lang="EN-MY">to detect, prevent
     or investigate security /peaches or fraud.</span></li>
</ul>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Release of
information</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">Any
personal data collected from an individual is for the purpose of transaction
made using FPX. We do not disclose your personal information to any third party
except when allowed or required by the law.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Rights and Storage</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We
will retain your personal information for as long as your personal information
is needed to provide you our service(s). Your personal information is used,
processed and stored in accordance with the all applicable laws relating to
personal information. Any enquiries regarding your personal information, please
contact us at </span><span lang="EN-MY" style="color:black"><a href="mailto:customersupport@paynet.my">customersupport@paynet.my</a></span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Use of cookies</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">We do
not use cookies to gather information. Cookies are pieces of information that
most sites place on your computer to help "customise" your visit to
the site. For example, a cookie will allow you to trace previously visited
pages, such as your screen name or where you left off in a game. Most websites
use cookies exactly for this purpose.</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Web Cache</span></b></p>

<p class="MsoNormal" style="margin-bottom:5.25pt;text-align:justify;text-justify:
inter-ideograph;"><span lang="EN-MY" style="color:#333333">FPX
system does not accommodate any web caching to prevent storing of files/data in
the hard disk cache and ensuring confidentiality of customer/business partner
information.</span></p>

<div class="MsoNormal" align="center" style="text-align:center"><span lang="EN-MY">

<hr size="0" width="100%" noshade="" style="color:#333333" align="center">

</span></div>

<p class="MsoNormal" style="margin-top:15.0pt;margin-right:0cm;margin-bottom:
7.5pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><span lang="EN-MY" style="color:#333333">Disclaimer</span></p>

<p class="MsoNormal" style="margin-top:3.75pt;margin-right:0cm;margin-bottom:
3.75pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
"><b><span lang="EN-MY" style="color:#333333">Disclaimer</span></b></p>

<ol style="margin-top:0cm" start="1" type="1">
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">You expressly agree that use of this page or website is at your
     sole risk. Neither PayNet nor its affiliates warrant that this page or
     website will be uninterrupted or error free; nor do they make any warranty
     as to the results that may be obtained from use of this page or website,
     or as to the accuracy, reliability or content of any information, service,
     or merchandise provided through this page or website.</span></li>
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">In addition, PayNet does not warrant or represent that access
     to the whole or part(s) of this page or website, the materials,
     information and/or functions contained therein will be provided
     uninterrupted or free from errors or that any identified defect will be
     corrected, or that there will be no delays, failures, errors or loss of
     transmitted information, that no viruses or other contaminating or
     destructive properties will be transmitted or that no damage will occur to
     your computer system.</span></li>
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">This page is provided on an “as is” basis without warranties of
     any kind, either express or implied, including, but not limited to,
     warranties of title or implied warranties of merchantability fitness for a
     particular purpose, accuracy, timeliness or completeness.</span></li>
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">This disclaimer of liability applies to any damages or injury
     caused by any failure of performance, error, omission, interruption,
     deletion, defect, delay in operation or transmission, computer virus,
     communication line failure, theft or destruction or unauthorised access
     to, alteration of, or use of record, whether for breach of contract,
     negligence or other tortious behaviour, or under any other cause of
     action. You specifically acknowledge that PayNet is not liable for the
     defamatory, offensive or illegal conduct of third-parties and that the
     risks of injury from the foregoing rest entirely with you.</span></li>
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">In no event will PayNet, be liable for any damages, including,
     without limitation, direct, indirect, incidental, special, consequential
     or punitive damages arising out of the use of or inability to use this
     page or website. You hereby acknowledge that this term is applicable
     whenever you access or use the content available on this page or website.</span></li>
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">In addition to the terms set forth above neither, PayNet, nor
     its affiliates, information providers or content partners shall be liable
     regardless of the cause or duration, for any errors, inaccuracies,
     omissions, or other defects in, or untimeliness or unauthenticity of, the
     information contained in this page or website, or for any delay or
     interruption in the transmission thereof to you, or for any claims or
     losses arising therefrom or occasioned thereby. None of the foregoing
     parties shall be liable for any third party claims or losses of any
     nature, including, but not limited to, lost profits, punitive or
     consequential damages. Neither, PayNet, nor its affiliates, information
     providers or content partners warrant or guarantee the timeliness,
     sequence, accuracy or completeness of the information contained in this
     page or website. Additionally, there are no warranties given as to the
     results obtained from the use of the said information.</span></li>
 <li class="MsoNormal" style="color:#333333;margin-bottom:5.25pt;text-align:justify;
     text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY">Reference to any specific commercial product, process or
     service by trade name, trade mark, manufacture or otherwise by PayNet or
     its affiliates does not constitute an endorsement, a recommendation or a
     favouring by PayNet.</span></li>
 <li class="MsoNormal" style="margin-bottom:0cm;margin-bottom:.0001pt;text-align:
     justify;text-justify:inter-ideograph;line-height:normal;"><span lang="EN-MY" style="color:#333333">You are solely responsible in your
     actions when evaluating the quality, adequacy, completeness and usefulness
     of the services, content, advice, opinions and other information obtained
     or accessible through this page or website and making any decision to
     transact using this page or website based on any the information provided
     therein.</span></li>
</ol>

</div>
`
